import * as React from 'react'

import { Template } from './Template'
import { useViewModel } from './useViewModel'

type SearchOverlayFormProps = {
  focusOnMount?: boolean
  initialSearchText?: string
  isMobileSearch?: boolean
  onAutoComplete?: (hasResults: boolean) => void
  onClearFormClick?: () => void
  onClickSearchOverlayProduct?: () => void
  onFormSubmit: (searchText: string) => void
  resultsInFrontOfBackdrop?: boolean
  shouldDisplaySearchOverlay: boolean
  ref?: React.RefObject<unknown>
}

export function SearchOverlayForm({
  focusOnMount = false,
  initialSearchText = '',
  isMobileSearch,
  onAutoComplete,
  onClearFormClick,
  onClickSearchOverlayProduct,
  onFormSubmit,
  resultsInFrontOfBackdrop = false,
  shouldDisplaySearchOverlay,
  ref,
}: SearchOverlayFormProps) {
  const viewModel = useViewModel({
    focusOnMount,
    initialSearchText,
    isMobileSearch,
    onAutoComplete,
    onClearFormClick,
    onClickSearchOverlayProduct,
    onFormSubmit,
    ref,
    shouldDisplaySearchOverlay,
  })

  return <Template resultsInFrontOfBackdrop={resultsInFrontOfBackdrop} {...viewModel} />
}
